module.exports = __webpack_public_path__ + "static/media/sql-server-icon-png-11352.cbe75e33.png";